import { native } from '@forest/native-services'
import { dialog } from '@forest/shared/solid'
import type { Unavailable } from '~/lib/bootstrap'
import { logNonFatal } from '~/lib/diagnostics'
import type { Screen } from '~/lib/screen'
import { m } from '~/paraglide/messages'

/**
 * Where the page lands when it cannot show (GLOSSARY.md "Resubscribe
 * paywall"): native gives it no way to close unrendered, so it reveals onto
 * this dialog alone. OK is the only way out of it, and closes the page.
 */
export function showUnavailable(
  { code, message }: Unavailable,
  launchScreen: Screen,
) {
  logNonFatal('resubscribe_paywall_unavailable', {
    reason: code,
    screen: launchScreen,
    ...(message !== undefined && { message }),
  })
  void dialog.open({
    title: m.dialog_something_went_wrong_title(),
    description: m.dialog_unexpected_error_content({ error_code: code }),
    button: m.OK(),
    // Async, so the dialog stays up until the WebView is gone: a failed close
    // leaves OK to press again rather than the blank page behind it.
    asyncAction: () => native.general.close().catch(() => {}),
    // Dismissing it any other way would leave the user on a blank page.
    closeOnEscapeKeyDown: false,
  })
}
